// extracted by mini-css-extract-plugin
export var hLtPattern1 = "Page_Acfbuilder_Wrapper_Content20-module--h-lt-pattern-1--1ff69";
export var hRtPattern1 = "Page_Acfbuilder_Wrapper_Content20-module--h-rt-pattern-1--30e8d";
export var iconMargin = "Page_Acfbuilder_Wrapper_Content20-module--icon-margin--0746c";